import React from 'react';
import { useSelector } from 'react-redux';

import PartyIcon from 'assets/images/popper.png';

function SignUpPrompts() {
  const isOpen = useSelector(state => state.utils.isRightSideBarOpen);
  const remainingPrompts = useSelector(state => state.chat.remainingPrompts);

  return (
    <div className='signup__prompts' style={{ cursor: 'pointer' }}>
      <div className='signup__prompts-grid'>
        <img src={PartyIcon} alt='Party Icon' />
        {isOpen && <p>Sign up to get {remainingPrompts + 10} free prompts!</p>}
      </div>
    </div>
  );
}

export default SignUpPrompts;
